export default __webpack_public_path__ + "static/media/leyland_daf.74d99917.png";